import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import ContentHeader from 'component/utils/ContentHeader'
import BodyParameters from 'component/ircAutonomous/bodyParameters'

import SuccessModal from 'component/Modal/SuccessModal'
import NewErrorModal from 'component/Modal/NewErrorModal'

import * as parametersActions from 'action/ircAutonomousParameters'

class IrcAutonomous extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    fetchRequest: PropTypes.func.isRequired,
    error: PropTypes.object,
    updateParameters: PropTypes.func.isRequired,
    allParameters: PropTypes.object,
    getParametersError: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = { loadedParameters: false, showModal : false, modal: ''}
  }

  componentDidMount() {
    const {
      auth: { user },
      fetchRequest,
    } = this.props

    /* istanbul ignore else */
    if (user) {
      this.setState({ loading: true })
      fetchRequest(user.dsToken).then(() => {
         if(this.props.getParametersError && this.props.getParametersError.cdStatus === 400) this.handleModal("warningModal")
      })
  }
}

  handleModal = (modalName) => this.setState({modal: modalName})

  handleSubmit = (args) => {
    const { auth, translate, updateParameters } = this.props

    if (args === null || args === undefined) {
      return
    }
    
    Object.keys(args).forEach((key) => {
      if (!!args[key] && typeof args[key] !== 'boolean') {
        let str = args[key].toString()

        // if has comma, remove dots
        if (str.indexOf(',') !== -1) {
          str = str.replace('.', '')
        }

        args[key] = Number(str.replace(/,/g, '.').replace('%', ''))
      }
    })

    args.cdLdap = auth.user.username; 
    args.dsLdap = auth.user.fullName; 


    const renderError = (resp) => {
      if (resp) {
        const errorMessage = resp.map((erroDetal) => erroDetal.dsDetail).join("\n");
        this.setState({ errorMessage });
        this.handleModal("warningModal");
      }
    }

    const respostaStatus = (resp) =>

    resp && resp.cdStatus === 200 ? this.handleModal("successModal") : renderError(resp)

    updateParameters(auth.user.dsToken, args)
    .then((resp) => {
      respostaStatus(resp);  
    })
    .catch(() => {
      const errorMessage = translate('punctual.adjust.parameters.saveError');
      this.setState({ errorMessage });  
      this.handleModal("warningModal"); 
    });
  }


  successModal = (translate) => (
    <SuccessModal 
      fillButton 
      center 
      handleClose={() => this.handleModal("")}  
      size='sm' 
      buttonText='OK' 
      msg={translate('stock.adjustment.parameters.success')} 
      t={translate} 
    />
  )

  warningModal = (translate) => (
    <NewErrorModal 
      fillButton 
      center 
      handleClose={() => this.handleModal("")} 
      size="sm" 
      msg={this.state.errorMessage || translate('parameters.autonomous.notFound')}
      t={translate} 
    />
  )

  renderModal = () => {
    const { modal } = this.state
    const { translate } = this.props
    switch (modal) {
      case 'successModal':
        return this.successModal(translate)
      case 'warningModal':
        return this.warningModal(translate)
      default:
        return null
    }
  }

  render() {
    const { translate, allParameters } = this.props

    return (
      <div>
        <ContentHeader>{translate('parameters.autonomous')}</ContentHeader>

        <BodyParameters
          translate={translate}
          allParameters={allParameters}
          submit={this.handleSubmit}
        />

       {this.renderModal()}
      </div>
    )
  }
}

/* istanbul ignore next */
const mapStateToProps = ({ parametersReducer }) => ({
  allParameters: parametersReducer.get.record,
  error: parametersReducer.save.error,
  getParametersError: parametersReducer.get.error
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => () =>
  bindActionCreators(parametersActions, dispatch)

/* istanbul ignore next */
const ParametersTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(IrcAutonomous)

/* istanbul ignore next */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ParametersTranslated)

export { IrcAutonomous }
